import React from 'react';
import { useTranslation } from 'react-i18next';
import './insights.scss';

type NoDataMessageProps = {
    isLoading: boolean;
    isResponseLengthTooLong: boolean;
};

const NoDataMessage = ({
    isLoading,
    isResponseLengthTooLong,
}: NoDataMessageProps) => {
    const { t } = useTranslation('measurement');

    return (
        !isLoading &&
        (isResponseLengthTooLong ? (
            <div className="-pos-abs -empty-table-container">
                <div className="rt-noData -empty-table">
                    <p>{t('dataExplorer.noData.rowLimitExceeded')}</p>
                    <p>{t('dataExplorer.noData.reduceGroupBy')}</p>
                    <p className="boldText">
                        {t('dataExplorer.noData.contactSupport')}
                    </p>
                </div>
            </div>
        ) : (
            <div className="-pos-abs -empty-table-container">
                <div className="rt-noData -empty-table">
                    <p>{t('dataExplorer.noData.noDataMessage')}</p>
                </div>
            </div>
        ))
    );
};

export default NoDataMessage;
